import { Switch } from "@mui/material";
import React, { useState } from "react";
import CommonDropdownInput from "../../common/inputs/CommonDropdownInput";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import { pointsConfig } from "../../../pointsConfig";

function PointsCreateMissionReferralCount({
  referralCount,
  data,
  setData,
  onReferralCountChange,
}) {
  const [afterBooking, setAfterBooking] = useState(false);
  const [extra, setExtra] = useState({
    count: "",
    timeFrame: "30 days",
    points: "",
  });

  return (
    <div className="w-ful flex flex-col pb-[100px]">
      <div className="w-ful flex flex-col gap-4 mb-2">
        <div className="flex w-full items-center justify-between gap-3">
          <span>Referral Conversion (Only after booking)</span>{" "}
          <Switch
            checked={referralCount?.onlyAfterBooking}
            onChange={() =>
              onReferralCountChange({
                ...referralCount,
                onlyAfterBooking: !referralCount?.onlyAfterBooking,
              })
            }
          />
        </div>
      </div>
      <CommonFreeTextInput
        value={
          referralCount?.referralCount
            ? Number(referralCount?.referralCount).toLocaleString()
            : ""
        }
        label="Referral Count"
        className="mt-4"
        onChange={(val) => {
          const numericVal = val.replace(/\D/g, "");
          onReferralCountChange({
            ...referralCount,
            referralCount: Number(numericVal),
          });
        }}
      />
      <CommonDropdownInput
        label="Time Frame"
        value={data?.timeFrame}
        onChange={(val) => setData({ ...data, timeFrame: val })}
        options={pointsConfig.timeFrameOptions}
        className="mt-4"
      />
      <CommonFreeTextInput
        value={Number(data?.pointsRewarded).toLocaleString()}
        label="Points Rewarded"
        className="mt-4"
        onChange={(val) => {
          const numericVal = val.replace(/\D/g, "");
          setData({ ...data, pointsRewarded: numericVal });
        }}
      />
    </div>
  );
}

export default PointsCreateMissionReferralCount;
